import React, { useState } from 'react';
import ChannelInitialIcon from '../ChannelInitialIcon/ChannelInitialIcon';
import { getAvatarColorForName } from '../../../utils/nameUtils';
import styles from './UserDisplay.module.css';

export interface UserAvatarProps {
  avatarUrl?: string | null;
  name: string;
  size?: number;
  className?: string;
}

const UserAvatar: React.FC<UserAvatarProps> = ({ 
  avatarUrl, 
  name, 
  size = 40,
  className = '' 
}) => {
  const [imageError, setImageError] = useState(false);
  const displayName = name || 'User';
  const fallbackBg = getAvatarColorForName(displayName);

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <div 
      className={`${styles.avatarWrapper} ${className}`}
      style={{ width: size, height: size }}
    >
      {avatarUrl && !imageError ? (
        <img
          src={avatarUrl}
          alt={displayName}
          className={styles.avatar}
          onError={handleImageError}
        />
      ) : (
        <div className={styles.avatarFallback} style={{ backgroundColor: fallbackBg, color: '#ffffff' }}>
          <ChannelInitialIcon channelName={displayName} size={size} />
        </div>
      )}
    </div>
  );
};

export default UserAvatar;

